// extracted by mini-css-extract-plugin
export var button = "_42-7";
export var buttonRow = "_42-6";
export var fadeIn = "_42-1";
export var gradient = "_42-0";
export var panel = "_42-2";
export var panelIn = "_42-3";
export var subtitle = "_42-5";
export var title = "_42-4";